module.exports = __webpack_public_path__ + "static/media/minimize.b4fb6519.svg";